export default __webpack_public_path__ + "static/media/Logo4.d8912692.png";